<div class="cl-toolbar-item cl-parent-menu-item">
    <div>
        <a *ngIf="isBackNavEnabled && !isBackNavDisabledOverride" [uiSref]="parentState" [uiParams]="parentParams" class="noselect cl-back-navigation">
            <mat-icon class="cl-back-icon">keyboard_arrow_left</mat-icon>
            <span class="noselect cl-current-menu-title">{{currentTitleOverride || currentTitle}}</span>
        </a>
        <a *ngIf="!isBackNavEnabled || isBackNavDisabledOverride" class="noselect">
            <span class="noselect cl-current-menu-title">{{currentTitleOverride || currentTitle}}</span>
        </a>
        <ng-content fxLayout="row" fxFlex></ng-content>
    </div>
</div>
